"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIsReservedWord = void 0;
const createIsReservedWord = reservedWords => word => reservedWords.some(reservedWord => reservedWord === word.toUpperCase());
exports.createIsReservedWord = createIsReservedWord;